export default __webpack_public_path__ + "static/media/4-min.66a7e9c2.jpg";